export const Autofocus = {
  inserted(el: Element) {
    if (el instanceof HTMLInputElement) {
      el.focus()
    }
  },
}
